export class User {
    constructor(public userId: number, public username: string, public password: string, public role: string) {
    }
}
export class RegistrationUser {
    firstname: string;
    lastname: string;
    email: string;
    password: string;

}

export class BackEndRegistration {
    first_name: string;
    last_name: string;
    username: string;
    password: string;
    company_registration_no: string;
    contact_no: string;
    address: string;
    company_name: string;
    tax_no: string;
    email: string;
    confirmPassword: string;
    webSite: string;
    stripe_source_token: string;
}

export class ProfileUser {
    address: string;
    company_name: string;
    company_registration_no: string;
    contact_no: string;
    seller_email: string;
    first_name: string;
    image_url: string;
    is_activate: string;
    last_name: string;
    seller_id: string;
    tax_no: string;
    user_id: string;
    user_type: string;
    username: string;
    website: string;
    summary: string;
    company_lon: number;
    company_lat: number;
}



// WEBPACK FOOTER //
// ./src/app/authentication/user.ts